// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_ir-0";